module.exports = __webpack_public_path__ + "img/13.1295bcd1.png";